let Values = {
  IPD                      : 'IPD',
  IPP                      : 'IPP',
  ANTEBRACHIAL             : 'ANTEBRACHIAL',
  BICIPITAL_BURSA          : 'BICIPITAL_BURSA',
  CALCANEAN_BURSA          : 'CALCANEAN_BURSA',
  OLECRANIAN_BURSA         : 'OLECRANIAN_BURSA',
  PODOTROCHLEAR_BURSA      : 'PODOTROCHLEAR_BURSA',
  CARPUS                   : 'CARPUS',
  ELBOW                    : 'ELBOW',
  COXOFEMORAL              : 'COXOFEMORAL',
  DIGITAL_DISTAL           : 'DIGITAL_DISTAL',
  DIGITAL_PROXIMAL         : 'DIGITAL_PROXIMAL',
  PATELLOFEMORAL           : 'PATELLOFEMORAL',
  LATERAL_FEMOROTIBIAL     : 'LATERAL_FEMOROTIBIAL',
  MEDIAL_FEMOROTIBIAL      : 'MEDIAL_FEMOROTIBIAL',
  CARPAL_SHEATH            : 'CARPAL_SHEATH',
  DIGITAL_SHEATH           : 'DIGITAL_SHEATH',
  TARSAL_SHEATH            : 'TARSAL_SHEATH',
  INTERCARPAL              : 'INTERCARPAL',
  DISTAL_INTERTARSAL       : 'DISTAL_INTERTARSAL',
  LEGGINGS                 : 'LEGGINGS',
  DISTAL_METACARPAL        : 'DISTAL_METACARPAL',
  PROXIMAL_METACARPAL      : 'PROXIMAL_METACARPAL',
  METACARPOPHALANGEAL      : 'METACARPOPHALANGEAL',
  DISTAL_METATARSAL        : 'DISTAL_METATARSAL',
  PROXIMAL_METATARSAL      : 'PROXIMAL_METATARSAL',
  METATARSOPHALANGEAL      : 'METATARSOPHALANGEAL',
  DEEP_FIBULAR_NERVE       : 'DEEP_FIBULAR_NERVE',
  SUPERFICIAL_FIBULAR_NERVE: 'SUPERFICIAL_FIBULAR_NERVE',
  MEDIAN_NERVE             : 'MEDIAN_NERVE',
  ULNAR_NERVE              : 'ULNAR_NERVE',
  PROXIMAL_SUSPENSOR       : 'PROXIMAL_SUSPENSOR',
  RADIO_CARPAL             : 'RADIO_CARPAL',
  TARSO_CRURAL             : 'TARSO_CRURAL',
  TARSO_METATARSAL         : 'TARSO_METATARSAL',
  SHOULDER                 : 'SHOULDER',
};

export default Object.seal({
  ...Values,

  /* All values */
  values: Object.keys(Values),

  /* Get name for value. */
  name: (value) => {
    switch (value) {

      case Values.IPD:
        return 'Interphalangienne distale';

      case Values.IPP:
        return 'Interphalangienne proximale';

      case Values.ANTEBRACHIAL:
        return 'Antébrachiale';

      case Values.BICIPITAL_BURSA:
        return 'Bourse bicipitale';

      case Values.CALCANEAN_BURSA:
        return 'Bourse calcanéenne';

      case Values.OLECRANIAN_BURSA:
        return 'Bourse olécranienne';

      case Values.PODOTROCHLEAR_BURSA:
        return 'Bourse podotrochléaire ';

      case Values.CARPUS:
        return 'Médiocarpienne / Radiocarpienne (Carpe)';

      case Values.ELBOW:
        return 'Coude';

      case Values.COXOFEMORAL:
        return 'Coxofémorale';

      case Values.DIGITAL_DISTAL:
        return 'Digitale distale';

      case Values.DIGITAL_PROXIMAL:
        return 'Digitale proximale';

      case Values.PATELLOFEMORAL:
        return 'Fémoro-patellaire';

      case Values.LATERAL_FEMOROTIBIAL:
        return 'Fémoro-tibiale latérale';

      case Values.MEDIAL_FEMOROTIBIAL:
        return 'Fémoro-tibiale médiale';

      case Values.CARPAL_SHEATH:
        return 'Gaine carpienne';

      case Values.DIGITAL_SHEATH:
        return 'Gaine digitale';

      case Values.TARSAL_SHEATH:
        return 'Gaine tarsienne';

      case Values.INTERCARPAL:
        return 'Intercarpienne';

      case Values.DISTAL_INTERTARSAL:
        return 'Intertarsienne distale';

      case Values.LEGGINGS:
        return 'Jambière';

      case Values.DISTAL_METACARPAL:
        return 'Métacarpienne distale';

      case Values.PROXIMAL_METACARPAL:
        return 'Métacarpienne proximale';

      case Values.METACARPOPHALANGEAL:
        return 'Métacarpophalangienne';

      case Values.DISTAL_METATARSAL:
        return 'Métatarsienne distale';

      case Values.PROXIMAL_METATARSAL:
        return 'Métatarsienne proximale';

      case Values.METATARSOPHALANGEAL:
        return 'Métatarsophalangienne';

      case Values.DEEP_FIBULAR_NERVE:
        return 'Nerf fibulaire profond';

      case Values.SUPERFICIAL_FIBULAR_NERVE:
        return 'Nerf fibulaire superficiel';

      case Values.MEDIAN_NERVE:
        return 'Nerf médian';

      case Values.ULNAR_NERVE:
        return 'Nerf ulnaire';

      case Values.PROXIMAL_SUSPENSOR:
        return 'Proximale du suspenseur';

      case Values.RADIO_CARPAL:
        return 'Radio-carpienne';

      case Values.TARSO_CRURAL:
        return 'Tarso-crurale';

      case Values.TARSO_METATARSAL:
        return 'Tarso-métatarsienne';

      case Values.SHOULDER:
        return 'Epaule';

      default:
        return value;
    }
  },

  /* Get short for value. */
  short: (value) => {
    switch (value) {

      case Values.IPD:
        return 'AIPD';

      case Values.IPP:
        return 'AIPP';

      case Values.ANTEBRACHIAL:
        return 'Antebrach';

      case Values.BICIPITAL_BURSA:
        return 'BrseBicip';

      case Values.CALCANEAN_BURSA:
        return 'BrseCalc';

      case Values.OLECRANIAN_BURSA:
        return 'BrseOlécr';

      case Values.PODOTROCHLEAR_BURSA:
        return 'BrsePodo';

      case Values.CARPUS:
        return 'Carp';

      case Values.ELBOW:
        return 'Coude';

      case Values.COXOFEMORAL:
        return 'CoxoFem';

      case Values.DIGITAL_DISTAL:
        return 'DigDist';

      case Values.DIGITAL_PROXIMAL:
        return 'DigProx';

      case Values.PATELLOFEMORAL:
        return 'AFemoroPat';

      case Values.LATERAL_FEMOROTIBIAL:
        return 'AFemoroTibL';

      case Values.MEDIAL_FEMOROTIBIAL:
        return 'AFemoroTibM';

      case Values.CARPAL_SHEATH:
        return 'GnCarp';

      case Values.DIGITAL_SHEATH:
        return 'GnDig';

      case Values.TARSAL_SHEATH:
        return 'GnTars';

      case Values.INTERCARPAL:
        return 'Intercarp';

      case Values.DISTAL_INTERTARSAL:
        return 'InterTarsDist';

      case Values.LEGGINGS:
        return 'Jambière';

      case Values.DISTAL_METACARPAL:
        return 'McDist';

      case Values.PROXIMAL_METACARPAL:
        return 'McProx';

      case Values.METACARPOPHALANGEAL:
        return 'AMcP';

      case Values.DISTAL_METATARSAL:
        return 'MtDist';

      case Values.PROXIMAL_METATARSAL:
        return 'MtProx';

      case Values.METATARSOPHALANGEAL:
        return 'AMtP';

      case Values.DEEP_FIBULAR_NERVE:
        return 'NFibPf';

      case Values.SUPERFICIAL_FIBULAR_NERVE:
        return 'NFibSup';

      case Values.MEDIAN_NERVE:
        return 'NMed';

      case Values.ULNAR_NERVE:
        return 'NUln';

      case Values.PROXIMAL_SUSPENSOR:
        return 'SuspProx';

      case Values.RADIO_CARPAL:
        return 'RadioCarp';

      case Values.TARSO_CRURAL:
        return 'TarsCrur';

      case Values.TARSO_METATARSAL:
        return 'ATMt';

      case Values.SHOULDER:
        return 'Épaule';

      default:
        return value;
    }
  }
});
